<template>
    <NuxtPwaManifest />
    <NuxtPwaAssets />
    <LoadingBar />
    <NuxtLayout>
        <NuxtPage />
    </NuxtLayout>
</template>
